var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.924,
    height: 81.81,
    viewBox: "0 0 73.924 81.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_336",
    x: 0,
    y: 0,
    width: 73.924,
    height: 81.81,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#11856b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_140",
    "data-name": "Groupe 140",
    transform: "translate(50 74.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_139",
    "data-name": "Groupe 139",
    transform: "translate(-41 -74.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0)",
    filter: "url(#Trac\\xE9_336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_336-2",
    "data-name": "Trac\\xE9 336",
    d: "M10.588-49.915V-23.51A1.391,1.391,0,0,1,9.2-22.12H-15.817V-42.966a1.391,1.391,0,0,0-1.39-1.39H-28.325a1.391,1.391,0,0,0-1.39,1.39V-22.12h-5.559a1.391,1.391,0,0,1-1.39-1.39V-49.915h.472a6.266,6.266,0,0,0,5.045-2.571.56.56,0,0,1,.069.1,6.226,6.226,0,0,0,4.982,2.467h1.751a6.249,6.249,0,0,0,5.114-2.655c.09.111.18.229.278.341a6.941,6.941,0,0,0,5.177,2.314H-12.3a6.941,6.941,0,0,0,5.177-2.314c.1-.111.188-.229.278-.341a6.249,6.249,0,0,0,5.114,2.655H.019A6.226,6.226,0,0,0,5-52.381a.56.56,0,0,1,.069-.1,6.266,6.266,0,0,0,5.045,2.571ZM3.639-31.848V-42.966a1.391,1.391,0,0,0-1.39-1.39H-7.479a1.391,1.391,0,0,0-1.39,1.39v11.118a1.391,1.391,0,0,0,1.39,1.39H2.25a1.391,1.391,0,0,0,1.39-1.39ZM-31.174-74.93a2.779,2.779,0,0,0-2.54,1.65l-6.979,15.7a3.415,3.415,0,0,0,.333,3.4,3.628,3.628,0,0,0,2.984,1.481h1.185a3.489,3.489,0,0,0,3.349-2.543l3.217-11.6,2.251-8.1Zm6.685,0L-29.444-57.1a3.471,3.471,0,0,0,.584,3.037,3.444,3.444,0,0,0,2.765,1.369h1.751a3.465,3.465,0,0,0,3.453-3.092l2.133-19.144Zm14.377,0h-5.851l-1.96,17.608a4.189,4.189,0,0,0,1.042,3.238,4.112,4.112,0,0,0,3.107,1.39H-12.3a4.112,4.112,0,0,0,3.107-1.39,4.189,4.189,0,0,0,1.042-3.238Zm8.526,0H-7.319l2.133,19.144a3.465,3.465,0,0,0,3.453,3.092H.019a3.444,3.444,0,0,0,2.765-1.369A3.471,3.471,0,0,0,3.368-57.1Zm9.225,1.65A2.779,2.779,0,0,0,5.1-74.93H1.3l2.251,8.1,3.217,11.6a3.489,3.489,0,0,0,3.349,2.543H11.3a3.626,3.626,0,0,0,2.984-1.481,3.414,3.414,0,0,0,.333-3.4Zm0,0",
    transform: "translate(50 74.93)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrest);
export default __webpack_public_path__ + "static/media/prest.7dd1520e0a5d4fe3590ef264f653713c.svg";
export { ForwardRef as ReactComponent };